<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;">
			<div>
				<el-tabs  >				
					<el-tab-pane  label="采集表" ></el-tab-pane>
			    </el-tabs>
			</div>
			<el-button v-if="permissionNodeList.CJBGL_add.hasEntitle == 1" @click="handleAdd">新增采集表</el-button> 
			<el-button v-if="permissionNodeList.CJBGL_del.hasEntitle == 1" @click="handleBatchDelete">删除采集表</el-button> 
			<!-- <el-button v-if="permissionNodeList.CJBGL_import.hasEntitle == 1" @click="handleBatchImport">批量导入</el-button> -->
			<el-button v-if="permissionNodeList.CJBGL_export.hasEntitle == 1" @click="exportData">数据导出</el-button>
		</el-col>
		<el-col :span="24" class="toolbar" style="padding: 0px;padding-bottom:8px;margin: 5px 0px;">
			
			<div style="float: left;" >
			<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 4px;box-sizing: border-box;">项目归属:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 150px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">采集表类型:</label>
				<el-select  v-model="filterForm.acquireType" placeholder="全部" style="width: 140px;">
					<el-option label="全部" value="all"></el-option>
					<el-option label="电表" value="0"></el-option>
					<el-option label="水表" value="1"></el-option>
					<el-option label="气表" value="2"></el-option>
					<el-option label="其他" value="3"></el-option>
				</el-select>
				<label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">采集表名称:</label>
				<el-input style="width: 180px;font-size: 14px;" placeholder="请输入采集表名称" v-model="filterForm.acquireName">
				</el-input>
				<label  style="width: 40px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">传感器编号:</label>
				<el-input style="width: 180px;font-size: 14px;" placeholder="请输入传感器编号" v-model="filterForm.sn">
				</el-input>
				<el-button style="margin-left: 15px;" @click="queryBtn()">查询</el-button>
			</div>
		</el-col>
	

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column  type="selection" width="80">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="140" sortable>
			</el-table-column>
			<el-table-column prop="acquireType" label="采集表类型" width="180" sortable>
			</el-table-column>
			<el-table-column prop="acquireName" label="采集表名称" width="200" sortable>
			</el-table-column>
			<el-table-column prop="addressCodesCount" label="采集地址码" width="180"  sortable>
				<template scope="scope">
					 <a style="text-decoration:underline;color: #2440b3;font-size:15px;font-weight: 400;" v-if="scope.row.addressCodesCount>0" target="_blank"  @click.stop="handleShowAddressCodes(scope.$index, scope.row)">{{scope.row.addressCodesCount}}</a>
					 <lable style="font-size:14px;" v-if="scope.row.addressCodesCount ==0">0</lable>
				</template>
			</el-table-column>
			<el-table-column prop="acquireAddress" label="采集表地址" width="200" sortable>
			</el-table-column>
			<el-table-column prop="sn"  label="传感器编号" width="160" sortable>
			</el-table-column>
			<el-table-column label="操作" width="180">
				<template scope="scope">
					<el-button size="small" v-if="permissionNodeList.CJBGL_edit.hasEntitle == 1" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
					<el-button size="small" v-if="permissionNodeList.CJBGL_config.hasEntitle == 1 " @click="handleSetting(scope.$index, scope.row)">采集参数配置</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增界面-->
		<el-dialog title="新增采集表" v-model="addFormVisible" :close-on-click-modal="false" @close="cancelAddSubmit">
			<el-form :model="addForm" label-width="120px" :rules="saveFormRules" ref="addForm">
				<el-form-item prop="acquireType" label="采集表类型"  >
					<el-select  v-model="addForm.acquireType" placeholder="请选择" style="width: 400px;">
						<el-option label="电表" value="0"></el-option>
						<el-option label="水表" value="1"></el-option>
						<el-option label="气表" value="2"></el-option>
						<el-option label="其他" value="3"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item prop="acquireName" label="采集表名称">
					<el-input v-model="addForm.acquireName" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item prop="acquireAddress" label="采集表地址">
					<el-input v-model="addForm.acquireAddress" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="addForm.projectId"  filterable placeholder="请选择" style="width: 400px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item label="传感器类型"  prop="deviceModel">
					<el-select   v-model="addForm.deviceModel" style="width: 400px"> 
						<el-option v-for="(item,index) in deviceModelList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="sn" label="传感器编号">
					<el-input v-model="addForm.sn"  auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item  label="数据模式" prop="modeType">
					<el-radio v-model="addForm.modeType" class="radio" label="0">大端模式</el-radio>
					<el-radio  v-model="addForm.modeType" class="radio" label="1">小端模式</el-radio>
				</el-form-item>
				<div  style="margin-left: 40px;margin-bottom: 15px;">
					<label style="color:red;">（以下设置数据需要下发到设备，请设置后过一段时间再打开本界面查看设置结果）</label>
				</div>
				<el-form-item  label="寄存器功能码" prop="registerFunctionCode">
					<el-radio v-model="addForm.registerFunctionCode" class="radio" label="03">03</el-radio>
					<el-radio  v-model="addForm.registerFunctionCode" class="radio" label="04">04</el-radio>
				</el-form-item>
				<el-form-item label="地址码设置(最多支持32个)" label-width="190px"  icon="el-icon-plus" style="margin-bottom: 6px;">
					<el-button class="el-icon-plus clolos1" @click="addAddressCodeItem()"></el-button>
				</el-form-item>

				<div v-for="(item,index) in addressCodeList"  v-bind:key="index" style="margin-left:20px;font-size:12px;margin-bottom: 5px;">
					<label   for="">表名称/户号</label>
					<el-input v-model="item.name" auto-complete="off"  style="height:26px;width:120px;"></el-input>
					<label style="margin-left:12px;">地址码</label>
					<el-input v-model="item.code" @blur="onAddressCodeChanged(item.code)" auto-complete="off" style="width:120px;"></el-input>
					<el-button class="el-icon-minus clolos1" @click="subAddressCodeItem(index)"></el-button>
				</div>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelAddSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="addSubmitButtonDisabled" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="采集表" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="saveFormRules" ref="editForm">
				<el-form-item prop="acquireType" label="采集表类型"  >
					<el-select  v-model="editForm.acquireType" placeholder="请选择" style="width: 400px;">
						<el-option label="电表" value="0"></el-option>
						<el-option label="水表" value="1"></el-option>
						<el-option label="气表" value="2"></el-option>
						<el-option label="其他" value="3"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item prop="acquireName" label="采集表名称">
					<el-input v-model="editForm.acquireName" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item prop="acquireAddress" label="采集表地址">
					<el-input v-model="editForm.acquireAddress" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="editForm.projectId"  filterable placeholder="请选择" style="width: 400px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item label="传感器类型"  prop="deviceModel">
					<el-select   v-model="editForm.deviceModel" style="width: 400px"> 
						<el-option v-for="(item,index) in deviceModelList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="sn" label="传感器编号">
					<el-input v-model="editForm.sn" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item  label="数据模式" prop="modeType">
					<el-radio v-model="editForm.modeType" class="radio" label="0">大端模式</el-radio>
					<el-radio  v-model="editForm.modeType" class="radio" label="1">小端模式</el-radio>
				</el-form-item>
				<div  style="margin-left: 40px;margin-bottom: 15px;">
					<label style="color:red;">（以下设置数据需要下发到设备，请设置后过一段时间再打开本界面查看设置结果）</label>
				</div>
				
				<el-form-item  label="寄存器功能码" prop="registerFunctionCode">
					<el-radio v-model="editForm.registerFunctionCode" class="radio" label="03">03</el-radio>
					<el-radio  v-model="editForm.registerFunctionCode" class="radio" label="04">04</el-radio>
				</el-form-item>
				<el-form-item label="地址码设置(最多支持32个)" label-width="190px"  icon="el-icon-plus" style="margin-bottom: 6px;">
					<el-button class="el-icon-plus clolos1" @click="addAddressCodeItem()"></el-button>
				</el-form-item>

				<div v-for="(item,index) in addressCodeList"  v-bind:key="index" style="margin-left:20px;font-size:12px;margin-bottom: 5px;">
					<label   for="">表名称/户号</label>
					<el-input v-model="item.name" auto-complete="off" style="height:26px;width:120px;"></el-input>
					<label style="margin-left:12px;">地址码</label>
					<el-input v-model="item.code" @blur="onAddressCodeChanged(item.code)" auto-complete="off" style="width:120px;"></el-input>
					<el-button class="el-icon-minus clolos1" @click="subAddressCodeItem(index)"></el-button>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelEditSubmit" >取消</el-button>
				<el-button type="primary" v-bind:disabled="editSubmitButtonDisabled"  @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--配置弹窗-->
		<el-dialog  title="采集参数配置" id="setting-dialog" v-model="settingFormVisible" :close-on-click-modal="false" @close="cancelSettingSubmit">
			<el-form :model="settingForm" label-width="120px" :rules="settingFormRules" ref="settingForm">
				<div v-for="(item,index) in this.settingForm.collectConfigList"  v-bind:key="index" style="margin-left:20px;font-size:12px;margin-bottom: 30px;">
					<div >
						<div > 
							<el-button  style="padding: 5px 8px;" class="el-icon-minus clolos1" @click="subCollectConfigItem(index)"></el-button>
							<label style="font-size:14px;font-weight: 400;color: #000;">  参数采集{{index+1}}</label>
						</div>
						<div style="overflow: hidden;"> 
						  <div style="overflow: hidden;"> 
							<div class="setting_item_01">
								<label class="setting_item_lable">参数解析方式</label>
								<el-select  v-model="item.analysisType" @change="onAnalysisTypeChanged(item.analysisType,index)" placeholder="请选择" style="width:110px;">
									<el-option label="按字节" value="0"></el-option>
									<el-option label="按比特" value="1"></el-option>
								</el-select>
					        </div>
							<div class="setting_item_01">
								<label class="setting_item_lable">采集开始地址</label>
								<el-input v-model="item.acquiseAddress" auto-complete="off" style="width:110px;"></el-input>
							</div>
							<div class="setting_item_01">
								<label class="setting_item_lable">读取寄存器个数</label>
								<el-select  v-model="item.registerNumber" @change="registerNumberChanged(item.registerNumber,index)" placeholder="请选择" style="width: 110px;">
									<el-option label="1" value="1"></el-option>
									<el-option label="2" value="2"></el-option>
									<el-option label="3" value="3"></el-option>
									<el-option label="4" value="4"></el-option>
								</el-select>
							</div>
							<div class="setting_item_01">
								<label class="setting_item_lable">字节数</label>
								<el-input v-model="item.paramByteNum" @blur="paramByteNumChanged(item.paramByteNum,index)" auto-complete="off" style="width:110px;"></el-input>
							</div>
						
							<div v-if="item.analysisType == '0'" class="setting_item_01">
								<label class="setting_item_lable">参数名称</label>
								<el-input v-model="item.byteParam.paramName" auto-complete="off" style="width:110px;"></el-input>
							</div>
						   </div>
						   <div style="overflow: hidden;"> 
							<div v-if="item.analysisType == '0'" class="setting_item_01">
								<label class="setting_item_lable" >数据类型</label>
								<el-select  v-model="item.byteParam.paramType" placeholder="请选择" style="width: 110px;">
									<el-option label="Float" value="Float"></el-option>
									<el-option label="INT32" value="INT32"></el-option>
									<el-option label="INT16" value="INT16"></el-option>
									<el-option label="UINT32" value="UINT32"></el-option>
									<el-option label="UINT16" value="UINT16"></el-option>
								</el-select>
							</div>
							<div v-if="item.analysisType == '0'" class="setting_item_03" >
								<label class="setting_item_lable">单位</label>
								<div>
									<el-select  v-model="item.byteParam.scaleFactor" placeholder="请选择" style="width: 110px;">
										<el-option label="1" value="1"></el-option>
										<el-option label="0.1" value="0.1"></el-option>
										<el-option label="0.01" value="0.01"></el-option>
										<el-option label="0.001" value="0.001"></el-option>
									</el-select>
									<el-input v-model="item.byteParam.unit" auto-complete="off" style="width:100px;"></el-input>
								</div>
							</div>
							<div v-if="item.analysisType == '1'" >
								<div style="clear:both;"></div> 
								<div v-for="(one,index2) in item.bitParams" v-bind:key="index2" style="margin-bottom:10px;padding-top:10px;margin-left:40px;"> 
									<div > 
									  <el-button style="padding: 5px 8px;" class="el-icon-minus clolos1" @click="subBitParamsItem(index,index2)"></el-button>
									  <label style="font-size:12px;font-weight: 400;color: #000;">  比特参数{{index2+1}}</label>
									</div>
									<div style="overflow: hidden;"> 
									<div class="setting_item_01">
										<label class="setting_item_lable">起始比特位</label>
										<el-select  v-model="one.startBit" @change="onBitChanged(one.startBit,1,index,index2)" placeholder="请选择" style="width: 110px;">
											<el-option
												v-for="bitItem in item.bitOptions"
												:key="bitItem.value"
												:label="bitItem.label"
												:value="bitItem.value">
											</el-option>
										</el-select>
									</div>
									<div class="setting_item_01">
										<label class="setting_item_lable">终止比特位</label>
										<el-select  v-model="one.endBit" @change="onBitChanged(one.endBit,2,index,index2)" placeholder="请选择" style="width: 110px;">
											<el-option
												v-for="bitItem in item.bitOptions"
												:key="bitItem.value"
												:label="bitItem.label"
												:value="bitItem.value">
											</el-option>
										</el-select>
									</div>
									<div  class="setting_item_01">
										<label class="setting_item_lable">参数名称</label>
										<el-input v-model="one.paramName" auto-complete="off" style="width:120px;"></el-input>
									</div>
									<div class="setting_item_01" style="margin-left: 16px;">
										<label class="setting_item_lable">解析方式</label>
										<el-select  v-model="one.parseType" placeholder="请选择" style="width: 110px;">
											<el-option label="解析值" value="0"></el-option>
											<el-option label="解析状态" value="1"></el-option>
										</el-select>
								    </div>
									</div>
									<div style="overflow: hidden;"> 
									<div class="setting_item_01" v-if="one.parseType == '0'">
										<label class="setting_item_lable" >数据类型</label>
										<el-select  v-model="one.paramType" placeholder="请选择" style="width: 100px;">
											<el-option label="Float" value="Float"></el-option>
											<el-option label="INT32" value="INT32"></el-option>
											<el-option label="INT16" value="INT16"></el-option>
											<el-option label="UINT32" value="UINT32"></el-option>
											<el-option label="UINT16" value="UINT16"></el-option>
										</el-select>
							        </div>
									<div class="setting_item_03" v-if="one.parseType == '0'">
										<label class="setting_item_lable">单位</label>
										<div >
											<el-select  v-model="one.scaleFactor" placeholder="请选择" style="width: 100px;">
												<el-option label="1" value="1"></el-option>
												<el-option label="0.1" value="0.1"></el-option>
												<el-option label="0.01" value="0.01"></el-option>
												<el-option label="0.001" value="0.001"></el-option>
											</el-select>
											<el-input v-model="one.unit" auto-complete="off" style="width:110px;"></el-input>
										</div>
									</div>
									</div> 
									<div style="clear:both;height:1px;"></div> 
									<div  v-if="one.parseType=='1'">
										<div v-for="(keyValue,indx3) in one.keyValues" v-bind:key="indx3" style="margin-bottom:10px;margin-top:10px;margin-left:20px;">
											<div > 
												<el-button style="with:60px;padding: 5px 8px;"  class="el-icon-minus clolos1" @click="subKeyValuesItem(index,index2,indx3)"></el-button>
												<label style="font-size:11px;font-weight: 400;color: #000;">  值状态{{indx3+1}}</label>
											</div>
											<div style="overflow: hidden;"> 
												<div class="setting_item_01">
													<label >值</label>
													<el-input v-model="keyValue.key" auto-complete="off" style="width:110px;"></el-input>
												</div>
												<div class="setting_item_01" style="width: 23%;">
													<label >状态</label>
													<el-input v-model="keyValue.value" auto-complete="off" style="width:110px;"></el-input>
												</div>
											</div>
											<div style="clear:both;height:1px;"></div> 
										</div>
										<div style="clear:both;height:1px;"></div> 
									    <el-button style="margin-top:12px;margin-left:20px;padding: 5px 8px;" class="el-icon-plus clolos1" @click="addKeyValuesItem(index,index2)">  值状态</el-button>
									</div>
									
								</div>
								<div style="clear:both;height:1px;"></div> 
								<el-button style="padding: 5px 8px;margin-left:40px;" class="el-icon-plus clolos1" @click="addBitParamsItem(index)">  比特参数</el-button>
							</div>
						   </div>
				        </div>
						</div>
						
						<div style="clear:both;height:1px;"></div> 
						
					</div>
					<el-form-item  label-width="290px" prop="modeType" icon="el-icon-plus"  style="margin-bottom: 6px;">
					  <el-button style="padding: 5px 8px;" class="el-icon-plus clolos1" @click="addCollectConfigItem()">  采集参数</el-button>
				    </el-form-item>
					
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelSettingSubmit">取消</el-button>
				<el-button type="primary" v-if="userRoleIdentity == 'admin'" v-bind:disabled="settingSubmitButtonDisabled" @click.native="settingSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--地址码列表-->
		<el-dialog title="地址码列表" v-model="showAddressCodesVisible" :close-on-click-modal="false" @close="cancelShowAddressCodes">
			<el-table :data="show_address_codes" size="mini" highlight-current-row  style="width: 100%;">
				<el-table-column  type="index" width="80">
				</el-table-column>
				<el-table-column prop="name" label="表名称/户号" width="300" sortable>
				</el-table-column>
				<el-table-column prop="code" label="地址码" width="300" sortable>
				</el-table-column>
		    </el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelShowAddressCodes">关闭</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				permissionNodeList:global.getPermissionNodeList(),
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				deviceModelList:[],
				editFormVisible: false,
				editLoading: false,
				saveFormRules: {
					acquireType:[
						{ required: true, message: '请选择采集表类型'},
					],
					acquireName: [
						{ required: true, message: '采集表名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],  
					acquireAddress: [
						{ required: true, message: '采集表地址不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到50个字符之间'}
					],  
					sn: [
						{ required: true, message: '编号不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					deviceModel:[
						{ required: true, message: '请选择传感器类型'},
					],
					projectId:[
					    { required: true, message: '请选择所属项目'},
					],
					modeType:[
					    { required: true, message: '请选择大端或小端'},
					],
					registerFunctionCode:[
					    { required: true, message: '请选择寄存器功能码'},
					]
				},
				addForm: {
					modeType:'0'
				},
				editForm: {
				},
				filterForm: {
					
				},
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				uploadUrl:global.apiBaseURL+'/acquire/upload',
				uploadHeader:{access_token:global.getAccessToken()},
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				filterDeviceModel:'',
				filterSysCode:'',
				projectList:[],
				addressCodeList : [],
				settingFormVisible:false,
				settingSubmitButtonDisabled:false,
				settingForm:{
					//采集参数列表
				    collectConfigList:[{acquiseAddress:'',analysisType:'0',paramByteNum:'',paramSort:'',registerNumber:'',byteParam:{},bitParams:[
						{paramName:"",startBit:0,endBit:0,parseType:"",scaleFactor:"",unit:"",keyValues:[{key:"",value:""}]}
					  ]
					}]
				},
				settingFormRules:{
					// alarmTimeout:[
					// 	{ required: true, message: '告警超时不能为空', trigger: 'blur' },
					// 	{ type: 'number', message: '告警超时必须为数字值', trigger: 'blur' },
					// ],
				},
				showAddressCodesVisible:false,
				show_address_codes:[],
			}
		},
		methods: {
			checkinlist(){
				 console.log(this.editForm.sysIdJoinCodes);
			},
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			get_list_data() {
				let param = {
					acquireName:this.filterForm.acquireName,
					acquireType:this.filterForm.acquireType,
					sn:this.filterForm.sn,
					pageNum: this.page,
					pageSize: 15
				};
				if(param.acquireType == 'all') param.acquireType = '';
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				this.listLoading = true;
				api.acquire_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					if(!tools.strIsEmpty(res.data.list))
					 for (let index = 0; index < res.data.list.length; index++) {
						if(res.data.list[index].acquireType == '0'){
							res.data.list[index].acquireType = '电表';
						}
						else if(res.data.list[index].acquireType == '1'){
							res.data.list[index].acquireType = '水表';
						}
						else if(res.data.list[index].acquireType == '2'){
							res.data.list[index].acquireType = '气表';
						}
						else if(res.data.list[index].acquireType == '3'){
							res.data.list[index].acquireType = '其他';
						}
						else{
							res.data.list[index].acquireType = "未知"
						}
					}
					res.data.list.forEach(one => {
						if(!tools.strIsEmpty(one.addressCodes)){
							let addressCodes =  one.addressCodes.split(',');
							one.addressCodesCount = addressCodes.length;
							let addressCodesArray = [];
							addressCodes.forEach(item => {
								let splits =  item.split('_');
								addressCodesArray.push({code:splits[0],name:splits[1]});
							})
							one.addressCodesArray = addressCodesArray;
						}
						else one.addressCodesCount =0;
					});
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
					this.listLoading = false;
				});
			},
			handleEdit: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.acquire_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						this.editForm = Object.assign({}, res.data);
						this.editForm.modeType = this.editForm.modeType.toString()
						this.editForm.projectId  = String(this.editForm.projectId);
						this.addressCodeList = [];
						if(!tools.strIsEmpty(this.editForm.addressCodes)){
							let addressCodes =  this.editForm.addressCodes.split(',')
							if(addressCodes && addressCodes.length>0){
								addressCodes.forEach((item, index)=>{
									if(!tools.strIsEmpty(item)){
										let temp = item.split('_');
										this.addressCodeList.push({code:temp[0],name:temp[1]})
									}
					            });
							}
						}
						this.editFormVisible = true;
					}
					else{
						tools.error(new Vue(),"没有查询到该抄表终端详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			queryBtn(){
				let param = Object.assign({}, this.filterForm);
				if(null != param.search_word)this.search_word = param.search_word;
				if(null != param.projectIds)this.projectIds = param.projectIds;
				this.get_list_data();
			},
			handleAdd: function () {
				let param = {};
				this.addFormVisible = true;
				this.addForm = {
					
				};	
				this.addressCodeList = [{code:'',name:''}];
			},
			addAddressCodeItem: function () {
				if(this.addressCodeList.length == 32) tools.error(new Vue(),"地址码设置最多支持32个");
				else{
					this.addressCodeList.push({code:'',name:''})
				}
			},
			subAddressCodeItem: function (index) {
				this.addressCodeList.splice(index, 1)
			},
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					
					if (valid) {
						this.addSubmitButtonDisabled=true;
						let param = Object.assign({}, this.addForm);
						var errorFlag = false;
						if(this.addressCodeList && this.addressCodeList.length >0){
							param.addressCodes = '';
							this.addressCodeList.forEach((item, index)=>{
								if((tools.strIsEmpty(item.name) || tools.strIsEmpty(item.code))){
									tools.error(new Vue(),"地址码设置"+(index+1)+": 表名称/户号或地址码为空");
									errorFlag = true;
									this.editSubmitButtonDisabled=false;
									return;
							    }
								else{
									if(parseInt(item.code) ==NaN || 1> parseInt(item.code) || parseInt(item.code) > 247){
										tools.error(new Vue(),"地址码设置"+(index+1)+": 请输入长度在1到247之间的正整数");
										errorFlag = true;
										this.editSubmitButtonDisabled=false;
										return;
									}
									if(index == this.addressCodeList.length-1){
										param.addressCodes += item.code+'_'+item.name;
									}
									else{
										param.addressCodes += item.code+'_'+item.name+',';
									}
								}
								
					        });
						}
						
						//校验有错的话 停止执行
						if(errorFlag)return;
						
						param.projectId = parseFloat(param.projectId);
						this.listLoading = true;
						let self = this;
						api.acquire_saveOrUpdate_request(param).then((res) => {
							this.addFormVisible = false;
							this.$refs.addForm.resetFields();
							this.addressCodeList = [];
							this.addSubmitButtonDisabled=false;
							tools.success(this,"新增成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.addSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			handleSelect(index){
				this.editForm.businessGroupIds = this.businessGroupIdsSelect;
            },
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.editSubmitButtonDisabled=true;
						let param = Object.assign({}, this.editForm);
						var errorFlag = false;
						if(this.addressCodeList && this.addressCodeList.length >0){
							param.addressCodes = '';
							this.addressCodeList.forEach((item, index)=>{
								if((tools.strIsEmpty(item.name) || tools.strIsEmpty(item.code))){
									tools.error(new Vue(),"地址码设置"+(index+1)+": 表名称/户号或地址码为空");
									errorFlag = true;
									this.editSubmitButtonDisabled=false;
									return;
							    }
								else{
									if(parseInt(item.code) ==NaN || 1> parseInt(item.code) || parseInt(item.code) > 247){
										tools.error(new Vue(),"地址码设置"+(index+1)+": 请输入长度在1到247之间的正整数");
										errorFlag = true;
										this.editSubmitButtonDisabled=false;
										return;
									}
									if(index == this.addressCodeList.length-1){
										param.addressCodes += item.code+'_'+item.name;
									}
									else{
										param.addressCodes += item.code+'_'+item.name+',';
									}
								}
					        });
							
						}
						//校验有错的话 停止执行
						if(errorFlag)return;

						param.projectId = parseFloat(param.projectId);
						this.listLoading = true;
						let self = this;
						api.acquire_saveOrUpdate_request(param).then((res) => {
							this.editFormVisible = false;
							this.$refs.editForm.resetFields();
							this.editSubmitButtonDisabled=false;
							this.addressCodeList = [];
							tools.success(this,"编辑成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.editSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			addCollectConfigItem: function () {
				if(this.settingForm.collectConfigList.length == 16) tools.error(new Vue(),"采集参数最多支持16个");
				else{
					this.settingForm.collectConfigList.push({acquiseAddress:'',analysisType:'0',paramByteNum:'',paramSort:'',
					registerNumber:'',byteParam:{},bitParams:[{paramName:"",bitOptions:[],startBit:"",endBit:"",parseType:"",scaleFactor:"",
					unit:"",keyValues:[{key:"",value:""}]}]});
				}
			},
			subCollectConfigItem: function (index) {
				this.settingForm.collectConfigList.splice(index, 1)
			},
		
			addBitParamsItem: function (index) {
				console.log(index)
				if(!tools.strIsEmpty(this.settingForm.collectConfigList[index].bitParams) && this.settingForm.collectConfigList[index].bitParams.length == 16) tools.error(new Vue(),"采集参数最多支持16个");
				else{
					if(tools.strIsEmpty(this.settingForm.collectConfigList[index].bitParams)){
						this.settingForm.collectConfigList[index].bitParams = [
						{
						paramName:"",startBit:"",endBit:"",parseType:"",scaleFactor:"",unit:"",keyValues:[{key:"",value:""}]
						}
						]
					}
					else{
						this.settingForm.collectConfigList[index].bitParams.push(
						{
						paramName:"",startBit:"",endBit:"",parseType:"",scaleFactor:"",unit:"",keyValues:[{key:"",value:""}]
						}
					   )
					}
				}
			},
			subBitParamsItem: function (index1,index2) {
				this.settingForm.collectConfigList[index1].bitParams.splice(index2, 1)
			},
			addKeyValuesItem: function (index1,index2) {
				console.log(index1,index2)
				if(this.settingForm.collectConfigList[index1].bitParams[index2].keyValues.length == 16) tools.error(new Vue(),"采集参数最多支持16个");
				else{
					this.settingForm.collectConfigList[index1].bitParams[index2].keyValues.push(
						{
						key:"",value:""
						}
					)
				}
			},
			subKeyValuesItem: function (index1,index2,index3) {
				console.log(index1,index2,index3)
				//if(!tools.strIsEmpty(this.settingForm.collectConfigList[index1].bitParams[index2].keyValues))
				this.settingForm.collectConfigList[index1].bitParams[index2].keyValues.splice(index3, 1)
			},
			handleSetting: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				this.settingFormVisible = true;
				this.settingForm['deviceId'] = row.deviceId;
				api.acquire_getAcquireParam_request(param).then((res) => {
					if(res.data && res.data.length >0){
						this.settingForm.collectConfigList = res.data ;
						this.settingForm.collectConfigList.forEach((item, index)=>{
							if(item.analysisType == '0'){
							   item.analysisType = '0';
							   item.byteParam = JSON.parse(item.byteParam.replace("\\",""));
							   item.bitParams =[
								{paramName:"",startBit:'',endBit:'',parseType:"",scaleFactor:"",unit:"",keyValues:[{key:"",value:""}]}
								];
						    }
							else{
							   item.byteParam = {paramName:'',paramType:'',scaleFactor:'',uint:''};
							   item.analysisType = '1';
							   item.bitParams = JSON.parse(item.bitParams.replace("\\",""));
							   console.log(this.settingForm.collectConfigList);
							   item.bitParams.forEach((one, index2)=>{
								 if(!tools.strIsEmpty(item.paramByteNum)){
										this.settingForm.collectConfigList[index].bitOptions = [];
										for(let i=0;i<item.paramByteNum*8;i++){
											this.settingForm.collectConfigList[index].bitOptions.push({value:i,lable:i}) 
										}
						          }
								  if(one.parseType  == '1'){
									  //值对
									  console.log(one.keyValues);
									    if(!tools.strIsEmpty(one.keyValues)){
											one.keyValues = one.keyValues.split(',');
											let keyValues = [];
											one.keyValues.forEach((two, index2)=>{
													let splits = two.split('_');
													if(splits.length ==2)
													keyValues.push({key:splits[0],value:splits[1]});
											})
											
											if(keyValues.length == 0){
													one.keyValues = [];
											}
											else {
												one.keyValues = keyValues;
											}
										}
										
								  }
							   })
							}
							console.log(this.settingForm.collectConfigList);
						})
						this.settingFormVisible = true;
					}
					else{
					//采集参数列表
				    this.settingForm.collectConfigList = [{acquiseAddress:'',analysisType:'0',paramByteNum:'',paramSort:'',registerNumber:'',byteParam:{},bitParams:[
							{paramName:"",startBit:"",endBit:"",parseType:"",scaleFactor:"",unit:"",keyValues:[{key:"",value:""}]}
						]
						}]
				     }
					
					
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			settingSubmit: function () {
				this.$refs.settingForm.validate((valid) => {
					if (valid) {
						this.listLoading = true;
						this.settingSubmitButtonDisabled=true;
						let deviceId = this.settingForm.deviceId; 
						//深度拷贝
						let collectConfigList = JSON.parse(JSON.stringify(this.settingForm.collectConfigList))
						var errorFlag = false;
						collectConfigList.forEach((item, index)=>{
							if(errorFlag){
								return;
							}
							item.paramSort = index +1;
							if(tools.strIsEmpty(item.acquiseAddress)){
								tools.error(new Vue(),"采集参数"+(index+1)+":"+"采集开始地址不能为空");
								errorFlag = true;
								return;
							}
							if(tools.strIsEmpty(item.registerNumber)){
								tools.error(new Vue(),"采集参数"+(index+1)+":"+"读取寄存器个数不能为空");
								errorFlag = true;
								return;
							}
							if(tools.strIsEmptyV2(item.paramByteNum)){
								tools.error(new Vue(),"采集参数"+(index+1)+":"+"字节数不能为空");
								errorFlag = true;
								return;
							}
							if(item.analysisType == '0'){
							   delete item.bitParams;
								if(tools.strIsEmpty(item.byteParam.paramName)){
									tools.error(new Vue(),"采集参数"+(index+1)+":"+"参数名称不能为空");
									errorFlag = true;
									return;
								}
								if(tools.strIsEmptyV2(item.byteParam.paramType)){
									tools.error(new Vue(),"采集参数"+(index+1)+":"+"数据类型不能为空");
									errorFlag = true;
									return;
								}
								if(tools.strIsEmptyV2(item.byteParam.scaleFactor)){
									tools.error(new Vue(),"采集参数"+(index+1)+":"+"单位倍数不能为空");
									errorFlag = true;
									return;
								}
								if(tools.strIsEmpty(item.byteParam.unit)){
									tools.error(new Vue(),"采集参数"+(index+1)+":"+"单位名称不能为空");
									errorFlag = true;
									return;
								}
						    }
							else{
								delete item.byteParam;
								item.bitParams.forEach((one, idx) => {
									console.log(one)
									if(tools.strIsEmptyV2(one.startBit) || tools.strIsEmptyV2(one.endBit)){
										console.log(one.startBit,one.endBit);
										tools.error(new Vue(),"起始比特位或终止比特位不能为空");
										errorFlag = true;
										return;
									}
									if(one.startBit > one.endBit ){
										tools.error(new Vue(),"起始比特位要小于终止比特位");
										errorFlag = true;
										return;
									}
									if(one.endBit < one.startBit ){
										tools.error(new Vue(),"终止比特位要大于起始比特位");
										errorFlag = true;
										return;
									}
									if(tools.strIsEmpty(one.paramName)){
										tools.error(new Vue(),"采集参数"+(index+1)+" 比特参数"+(idx+1)+":"+"参数名称不能为空");
										errorFlag = true;
										return;
								    }
									if(tools.strIsEmpty(one.parseType)){
										tools.error(new Vue(),"采集参数"+(index+1)+" 比特参数"+(idx+1)+":"+"解析方式不能为空");
										errorFlag = true;
										return;
								    }
									if(one.parseType  == '0'){
										if(tools.strIsEmptyV2(one.paramType)){
											tools.error(new Vue(),"采集参数"+(index+1)+" 比特参数"+(idx+1)+":"+"数据类型不能为空");
											errorFlag = true;
											return;
										}
										if(tools.strIsEmptyV2(one.scaleFactor)){
											tools.error(new Vue(),"采集参数"+(index+1)+" 比特参数"+(idx+1)+":"+"单位倍数不能为空");
											errorFlag = true;
											return;
										}
										if(tools.strIsEmpty(one.unit)){
											tools.error(new Vue(),"采集参数"+(index+1)+" 比特参数"+(idx+1)+":"+"单位名称不能为空");
											errorFlag = true;
											return;
										}
										if(!tools.strIsEmpty(one.keyValues))delete one.keyValues;
										
								    }
									else if(one.parseType  == '1'){
										let  keyValuesStr = '';
										if(!tools.strIsEmpty(one.keyValues)){
											one.keyValues.forEach((two, index3)=>{
											if(errorFlag){
											   return;
										    }
											if(tools.strIsEmpty(two.key)){
												console.log(index3,two)
												tools.error(new Vue(),"采集参数"+(index+1)+" 比特参数"+(idx+1)+" 值状态参数"+(index3+1)+":"+"值不能为空");
												errorFlag = true;
												return;
											}
											if(tools.strIsEmpty(two.value)){
												console.log(index3,two)
												tools.error(new Vue(),"采集参数"+(index+1)+" 比特参数"+(idx+1)+" 值状态参数"+(index3+1)+":"+"状态不能为空");
												errorFlag = true;
												return;
											}

											if(index3 < one.keyValues.length-1){
												keyValuesStr += two.key + '_'+ two.value+',';
											}
											else{
												keyValuesStr += two.key + '_'+ two.value;
											}
											console.log(keyValuesStr)
											
										  })
										}
										if(errorFlag){
											keyValuesStr = '';
											return;
										}
										if(!tools.strIsEmpty(keyValuesStr))one.keyValues = keyValuesStr;
									}

									item.bitParams.forEach((two, idx2) => {
										if(idx != idx2){
											if(two.startBit<=one.startBit && one.startBit<=two.endBit){
												tools.error(new Vue(),"比特位选择重复");
												errorFlag = true;
												return;
									        }
											if(two.startBit<=one.endBit && one.endBit<=two.endBit){
												tools.error(new Vue(),"比特位选择重复");
												errorFlag = true;
												return;
									        }
										}
									})

									if(one.parseType  == '1'){
										
									}

									if(errorFlag){
										return;
									}
				                })
								if(errorFlag){
									return;
								}
								
							}
							if(errorFlag){
							   return;
						    }
					    });
						if(errorFlag){
							this.settingSubmitButtonDisabled=false;
							this.listLoading = false;
							return;
						}
						let param = collectConfigList;
						param['deviceId'] = deviceId;
						console.log(param)
						api.acquire_configAcquireParam_request(param).then(
							res => {
								this.listLoading = false;
								this.settingFormVisible = false;
								this.$refs.settingForm.resetFields();
								this.settingSubmitButtonDisabled=false;
								this.settingForm.collectConfigList = [{acquiseAddress:'',analysisType:'0',paramByteNum:'',paramSort:'',registerNumber:'',byteParam:{},bitParams:[
							          {paramName:"",startBit:"",endBit:"",parseType:"",scaleFactor:"",unit:"",keyValues:[{key:"",value:""}]}
						          ]}];
								tools.success(this,"配置成功");
								this.get_list_data();
							}
						).catch(function (e) {
							console.log(e);
							self.settingSubmitButtonDisabled=false;
							if(e.message)tools.error(new Vue(),e.message);
							this.listLoading = false;
						});	
					}
				})
			},
			cancelSettingSubmit(){
				this.settingFormVisible = false;
				for (let index = 0; index < this.$refs.settingForm.fields.length; index++) {
					if((this.$refs.settingForm.fields[index] == undefined) || (this.$refs.settingForm.fields[index].prop == undefined))delete this.$refs.settingForm.fields[index];
				}
				this.$refs.settingForm.resetFields();
				this.settingForm.collectConfigList = [{acquiseAddress:'',analysisType:'0',paramByteNum:'',paramSort:'',registerNumber:'',byteParam:{},bitParams:[
							          {paramName:"",startBit:"",endBit:"",parseType:"",scaleFactor:"",unit:"",keyValues:[{key:"",value:""}]}
						          ]}];
				if(this.settingSubmitButtonDisabled)this.settingSubmitButtonDisabled = false;
			},
			getDeviceModelList: function () {
				let param = {dataType:''};
				api.acquire_getAcquireModelList_request(param).then((res) => {
					if(res.data){
						this.deviceModelList = res.data;	
					}
				}).catch(function (e) {
					console.log(e);
				});
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseFloat(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			
			handleBatchDelete:function () {
				if(this.tableSelectionIds.length == 0){
					tools.error(this,"请先选择要删除的数据");
					return
				}
				this.$confirm('确认删除吗?', '提示', {showClose:false}).then(() => {
				    let param = {ids:this.tableSelectionIds};
					api.acquire_batchRemove_request(param).then(
						res => {
							if(res.code == 200){
								tools.success(this,"删除成功");
							    this.get_list_data();
							}
							else{
								tools.error(new Vue(),res.msg);
							}
						}
					).catch((e) => {
						console.log(e);
						if(e.message)tools.error(new Vue(),e.message);
				    });	
				})
				.catch(function(e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				 });
			},
		
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.deviceId;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.deviceId;
				})
			},
			exportData:function () {
				let param = {
					acquireName:this.filterForm.acquireName,
					acquireType:this.filterForm.acquireType,
					sn:this.filterForm.sn,
				};
				if(param.acquireType == 'all') param.acquireType = '';
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				this.listLoading = true;
				api.acquire_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'acquireManageList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				this.addressCodeList = [];
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			cancelEditSubmit(){
				this.editFormVisible = false;
				this.$refs.editForm.resetFields();
				this.addressCodeList = [];
				if(this.editSubmitButtonDisabled)this.editSubmitButtonDisabled = false;
			},
			handleShowAddressCodes:function (index, row) {
				this.show_address_codes = row.addressCodesArray;
				this.showAddressCodesVisible = true;
			},
			cancelShowAddressCodes(){
				this.showAddressCodesVisible = false;
				this.show_address_codes = [];
			},
			registerNumberChanged(val,index){
				let registerNumber = this.settingForm.collectConfigList[index].registerNumber;
				this.settingForm.collectConfigList[index].paramByteNum = registerNumber *2;
				this.settingForm.collectConfigList[index].bitOptions = []
				for(let i=0;i<this.settingForm.collectConfigList[index].paramByteNum*8;i++){
					this.settingForm.collectConfigList[index].bitOptions.push({value:i,lable:i}) 
				}
				console.log(
				this.settingForm.collectConfigList[index].bitOptions)
				console.log(
				this.settingForm.collectConfigList)
			},
			onAnalysisTypeChanged(analysisType,index){
				console.log(analysisType,index)
				if(analysisType  == '0'){
					console.log(analysisType,index)
					if(tools.strIsEmpty(this.settingForm.collectConfigList[index].byteParam)){
						console.log(this.settingForm.collectConfigList[index].byteParam)
						this.settingForm.collectConfigList[index].byteParam ={paramName:'',paramType:'',scaleFactor:'',uint:''};
					}
				}
				if(analysisType  == '1'){
					console.log(analysisType,index,this.settingForm.collectConfigList[index].bitParams)
					//.paramName) 
					//&&tools.strIsEmpty(this.settingForm.collectConfigList[index].bitParams.startBit
					if(tools.strIsEmpty(this.settingForm.collectConfigList[index].bitParams)){
						console.log('hahah');
						this.settingForm.collectConfigList[index].bitParams =[
						{paramName:"",startBit:'',endBit:'',parseType:"",scaleFactor:"",unit:"",keyValues:[{key:"",value:""}]}
					    ];
					}
					let paramByteNum = this.settingForm.collectConfigList[index].paramByteNum;
					console.log(paramByteNum);
					if(!tools.strIsEmpty(paramByteNum)){
						console.log(paramByteNum);
						this.settingForm.collectConfigList[index].bitOptions = []
						for(let i=0;i<paramByteNum*8;i++){
							this.settingForm.collectConfigList[index].bitOptions.push({value:i,lable:i}) 
						}
					}
					this.settingForm.collectConfigList[index].registerNumber = this.settingForm.collectConfigList[index].registerNumber+'';
				}
				console.log(analysisType,index,this.settingForm.collectConfigList)
			},
			paramByteNumChanged(val,index){
				let registerNumber = this.settingForm.collectConfigList[index].registerNumber;
				if(!tools.strIsEmpty(registerNumber)){
					if( val > registerNumber*2){
					   tools.error(new Vue(),"参数采集"+(index+1)+" 的字节数输入值不能大于寄存器个数*2");
					   return;
					}	
					console.log(val,index,this.settingForm.collectConfigList[index].bitOptions)
					this.settingForm.collectConfigList[index].bitOptions = [];
					for(let i=0;i<val*8;i++){
						this.settingForm.collectConfigList[index].bitOptions.push({value:i,lable:i}) 
					}
					console.log(val,index,this.settingForm.collectConfigList[index].bitOptions)
				}
				console.log(analysisType,index,this.settingForm.collectConfigList)
				
			},
			onAddressCodeChanged(val){
				let value = parseInt(val);
				if(isNaN(value) || 1> value || value> 247){
					tools.error(new Vue(),"地址码输入错误,请输入长度在1到247之间的正整数");
				}
			},
			onBitChanged(val,type,index,index2){
				let bitParams = this.settingForm.collectConfigList[index].bitParams;
				bitParams.forEach((one, idx) => {
					if(idx == index2){
						if(type == 1){
							if(!tools.strIsEmpty(one.endBit)){
								if(val > one.endBit )tools.error(new Vue(),"起始比特位要小于终止比特位");
							}
						}
						if(type == 2){
							if(!tools.strIsEmptyV2(one.startBit)){
								if(val < one.startBit )tools.error(new Vue(),"终止比特位要大于起始比特位");
							}
						}
					}
					else{
						if(one.startBit<=val && val<=one.endBit){
							tools.error(new Vue(),"比特位选择重复");
					    }
					}
				})
			}
		},
		mounted() {
			this.get_list_data();
			this.getDeviceModelList();
			this.getProjectTree();
			this.getShortAcountList(null);
		}
	}

</script>

<style scoped>
 .setting_item_01 {
	float: left;
	width: 18.83333%;
	padding-left:10px;
	padding-right:10px;
	padding-top:8px;
	box-sizing: border-box;
 }
 .setting_item_02 {
	float: left;
	width: 12.83333%;
	padding-left:10px;
	padding-right:10px;
	padding-top:8px;
	box-sizing: border-box;
 }
 .setting_item_03 {
	float: left;
	width: 38.83333%;
	padding-left:10px;
	padding-right:10px;
	padding-top:8px;
	box-sizing: border-box;
 }
 .setting_item_lable {
	margin-top:5px;
	margin-bottom:5px;
	display: block;
 }

 .setting_add {
    position: absolute;
    left: 50%;
	bottom: 20%;
 }
 
 #setting-dialog .el-dialog--small{
	width: 80%!important;
 }

</style>


// WEBPACK FOOTER //
// acquire_manage_list.vue?240d55d6